import { Link } from "react-router";
import styled from "styled-components";
import PreloadImage from "./AsyncImage";

const Container = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: var(--green);
    color: var(--white);
    background-image: radial-gradient(
        30% 80% at 60% 0%,
        #60e15e 15%,
        var(--green) 100%
    );
    min-height: 40rem;

    @media (max-width: 1000px) {
        min-height: 60rem;
    }

    .title-wrapper {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding-top: 5rem;
        z-index: 1;

        img {
            width: 53rem;

            @media screen and (max-width: 1000px) {
                width: 45rem;
            }

            @media screen and (max-width: 600px) {
                width: 34rem;
            }
        }
    }

    .assets-wrapper {
        display: flex;
        width: 100%;
        height: 38rem;

        .smurfs-section {
            position: relative;
            display: flex;
            justify-content: end;
            width: 65%;

            @media (max-width: 1000px) {
                width: 90%;
            }

            .smurf-box {
                position: absolute;
                right: -6rem;
                bottom: -1.5rem;

                @media screen and (max-width: 1000px) {
                    right: -5rem;
                }

                .smurfete-banner {
                    position: absolute;
                    width: 28rem;
                    bottom: 2.8rem;
                    right: 26rem;
                    z-index: 1;

                    @media screen and (max-width: 1000px) {
                        width: 23rem;
                        right: 21rem;
                    }

                    @media screen and (max-width: 600px) {
                        width: 21rem;
                        right: 19rem;
                    }
                }

                .smurf-dad-banner {
                    position: absolute;
                    width: 36rem;
                    bottom: 0;
                    right: -1rem;
                    z-index: 1;

                    @media screen and (max-width: 1000px) {
                        width: 28rem;
                    }
                }
            }
        }

        .text-section {
            position: relative;
            display: flex;
            align-items: center;
            width: 35%;
            height: 55%;

            @media (max-width: 1000px) {
                position: absolute;
                display: flex;
                align-items: center;
                justify-content: center;
                text-align: center;
                width: 100%;
                height: 15%;
            }

            p {
                font-family: "Professor Marbles 3";
                font-weight: 400;
                font-size: 2.3rem;
                line-height: 2rem;
                width: 60%;

                @media screen and (max-width: 1000px) {
                    width: 75%;
                    font-size: 1.7rem;
                    line-height: 1.7rem;
                }

                b {
                    color: var(--yellow);
                }
            }
        }

        .ground {
            position: absolute;
            width: 95rem;
            height: 8rem;
            bottom: 0;
            right: 0;
            z-index: 1;

            @media screen and (max-width: 1000px) {
                height: 12rem;
            }
        }

        .vegetation-1 {
            position: absolute;
            width: 32.5rem;
            right: 51%;
            bottom: 7rem;
            z-index: 1;

            @media screen and (max-width: 1000px) {
                width: 40rem;
                right: 40%;
                bottom: 10rem;
            }
        }

        .vegetation-2 {
            position: absolute;
            width: 62.5rem;
            right: 54%;
            bottom: -1rem;
            z-index: 2;

            @media screen and (max-width: 1000px) {
                display: none;
            }
        }

        .vegetation-3 {
            position: absolute;
            width: 50rem;
            right: 7rem;
            bottom: -1rem;
            z-index: 2;

            @media screen and (max-width: 1000px) {
                right: 10rem;
                width: 55rem;
                z-index: 2;
            }
        }

        .bush {
            position: absolute;
            width: 50rem;
            right: 60%;
            bottom: 4rem;
            transform: rotateY(180deg);
            z-index: 0;

            @media screen and (max-width: 1000px) {
                display: none;
            }
        }
    }

    .bg-assets-wrapper {
        position: absolute;
        width: 100%;
        height: 100%;
        right: 0;
        overflow: hidden;

        .tree {
            position: absolute;
            width: 38rem;
            right: 0;
            bottom: 0;
            z-index: 2;

            @media screen and (max-width: 1000px) {
                width: 40rem;
                right: -8rem;
            }
        }

        .dark-pattern {
            position: absolute;
            width: 100rem;
            right: -40rem;
            top: -35rem;
            opacity: 0.1;

            @media screen and (max-width: 1000px) {
                width: 80rem;
            }
        }

        .light-pattern {
            position: absolute;
            width: 90rem;
            right: 70rem;
            top: -10rem;
            opacity: 0.35;

            @media screen and (max-width: 1000px) {
                display: none;
            }
        }

        .light-camouflage {
            position: absolute;
            width: 115rem;
            top: 0;
            left: 0;
            opacity: 0.35;

            @media screen and (max-width: 1000px) {
                left: -10rem;
            }
        }
    }
`;

const GreenSection = () => {
    const hideSpot = Math.floor(window.innerWidth / 2.3);

    return (
        <Link to={"/ingressos"} style={{ textDecoration: "none" }}>
            <Container>
                <div className="bg-assets-wrapper">
                    <img
                        src="/green-section/tree.png"
                        className="tree no-shadow"
                        alt=""
                    />
                    <img
                        src="/tickets/dark-pattern.png"
                        className="dark-pattern no-shadow"
                        alt=""
                    />
                    <img
                        src="/green-section/light-pattern.png"
                        className="light-pattern no-shadow"
                        alt=""
                    />
                    <img
                        src="/green-section/light-camuflagem.png"
                        className="light-camouflage no-shadow"
                        alt=""
                    />
                </div>
                <div className="title-wrapper">
                    <img
                        src="/green-section/title.png"
                        alt="Qual ingresso combina com você?"
                        className="no-shadow"
                    ></img>
                </div>
                <div className="assets-wrapper">
                    <img
                        src="/green-section/ground.png"
                        className="ground no-shadow"
                        alt=""
                    />
                    <img
                        src="/attraction/vegeatation.png"
                        alt=""
                        className="vegetation-1 no-shadow"
                    />
                    <img
                        src="/attraction/vegeatation.png"
                        alt=""
                        className="vegetation-2 no-shadow"
                    />
                    <img
                        src="/attraction/vegeatation.png"
                        alt=""
                        className="vegetation-3 no-shadow"
                    />
                    <img
                        src="/green-section/bush.png"
                        className="bush no-shadow"
                        alt=""
                    />
                    <div className="smurfs-section">
                        <div className="smurf-box">
                            <PreloadImage
                                initial={{
                                    opacity: 1,
                                    x: -hideSpot,
                                }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ delay: 0.2, duration: 1 }}
                                src="/tickets/smurfete-ticket.png"
                                className="smurfete-banner no-shadow"
                                alt="Smurfete segurando ticket blue"
                            />
                            <PreloadImage
                                initial={{
                                    opacity: 1,
                                    x: hideSpot,
                                }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ delay: 0.2, duration: 1 }}
                                className="smurf-dad-banner no-shadow"
                                src="/tickets/smurf-ticket.png"
                                alt="Papai smurf segurando ticket blue premium"
                            />
                        </div>
                    </div>
                    <div className="text-section">
                        <p>
                            Saiba a diferença entre os <b>ingressos</b> blue e
                            blue premium!
                        </p>
                    </div>
                </div>
            </Container>
        </Link>
    );
};

export default GreenSection;
